(function () {
  'use strict';

  function formatMoney(cents) {
    var format = window.GoLevitaMoneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal   = (decimal   == null) ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts   = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2  = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents2;
    }
    var match = format.match(placeholder);
    var type  = match ? match[1] : 'amount';
    var value;
    switch (type) {
      case 'amount_no_decimals':                      value = fmt(cents, 0);           break;
      case 'amount_with_comma_separator':             value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default:                                        value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  var els = {};

  function open() {
    if (!els.cart) return;
    els.cart.classList.add('open');
    els.scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!els.cart) return;
    els.cart.classList.remove('open');
    els.scrim.classList.remove('open');
    document.body.style.overflow = '';
  }

  function threshold() {
    var raw = els.cart && els.cart.dataset.freeShippingThreshold;
    return Math.round(parseFloat(raw || '0') * 100);
  }

  function buildRow(item) {
    var imgSrc = (item.image || '').replace(/(\.\w+)$/, '_160x$1');
    var row = document.createElement('div');
    row.className = 'flex gap-4 bg-paper-100 rounded-2xl p-3';
    row.setAttribute('data-line-key', item.key);
    row.innerHTML =
      '<img src="' + imgSrc + '" alt="' + escAttr(item.title) + '" width="80" height="80" class="w-20 h-20 rounded-xl object-cover bg-paper-200">' +
      '<div class="flex-1">' +
        '<div class="font-medium text-sm leading-tight">' + escHtml(item.product_title) + '</div>' +
        '<div class="text-xs text-ink-900/60 mt-1">' + formatMoney(item.final_price) + '</div>' +
        '<div class="mt-2 flex items-center gap-2">' +
          '<button class="qty-dec w-11 h-11 md:w-7 md:h-7 rounded-full border border-ink-900/20 text-sm"' +
            ' data-line-key="' + escAttr(item.key) + '" data-qty="' + item.quantity + '"' +
            ' aria-label="Decrease quantity">&#8722;</button>' +
          '<span class="text-sm w-5 text-center">' + item.quantity + '</span>' +
          '<button class="qty-inc w-11 h-11 md:w-7 md:h-7 rounded-full border border-ink-900/20 text-sm"' +
            ' data-line-key="' + escAttr(item.key) + '" data-qty="' + item.quantity + '"' +
            ' aria-label="Increase quantity">+</button>' +
          '<button class="qty-rm ml-auto text-xs text-ink-900/50 underline underline-offset-4 hover:text-hv-600 min-h-[44px] md:min-h-0 px-2 py-2 inline-flex items-center"' +
            ' data-line-key="' + escAttr(item.key) + '">remove</button>' +
        '</div>' +
      '</div>';
    return row;
  }

  function escAttr(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function render(cart) {
    if (!els.cart) return;

    /* count badge */
    if (els.cartCount) {
      var prevCount = els.cartCount.textContent;
      els.cartCount.textContent = cart.item_count > 0 ? cart.item_count : '';
      els.cartCount.style.display = cart.item_count > 0 ? '' : 'none';
      if (String(cart.item_count) !== prevCount) {
        els.cartCount.classList.add('pulse');
        setTimeout(function () {
          els.cartCount.classList.remove('pulse');
        }, 600);
      }
    }

    /* empty state */
    var hasItems = cart.items && cart.items.length > 0;
    if (els.cartEmpty) {
      els.cartEmpty.style.display = hasItems ? 'none' : '';
    }

    /* rebuild item rows (keep #cartEmpty node, remove old rows) */
    var container = els.cartItems;
    if (container) {
      /* remove all children that are item rows */
      var existing = container.querySelectorAll('[data-line-key]');
      for (var i = 0; i < existing.length; i++) {
        if (!existing[i].id) {
          container.removeChild(existing[i]);
        }
      }
      if (cart.items) {
        cart.items.forEach(function (item) {
          container.appendChild(buildRow(item));
        });
      }
    }

    /* subtotal */
    if (els.cartTotal) {
      els.cartTotal.textContent = formatMoney(cart.total_price);
    }

    /* free shipping note */
    if (els.freeship) {
      var thresh = threshold();
      var remaining = thresh - cart.total_price;
      els.freeship.textContent = remaining > 0 ? formatMoney(remaining) + ' to go' : 'Free shipping unlocked!';
    }

    /* rebind row handlers */
    bindRowHandlers();
  }

  function bindRowHandlers() {
    var container = els.cartItems;
    if (!container) return;

    container.querySelectorAll('.qty-dec').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        var row = btn.closest('[data-line-key]');
        if (row) {
          row.querySelectorAll('.qty-dec, .qty-inc').forEach(function (b) {
            b.disabled = true;
            b.classList.add('pointer-events-none', 'opacity-50');
          });
        }
        change(key, qty - 1);
      });
    });

    container.querySelectorAll('.qty-inc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        var row = btn.closest('[data-line-key]');
        if (row) {
          row.querySelectorAll('.qty-dec, .qty-inc').forEach(function (b) {
            b.disabled = true;
            b.classList.add('pointer-events-none', 'opacity-50');
          });
        }
        change(key, qty + 1);
      });
    });

    container.querySelectorAll('.qty-rm').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        change(key, 0);
      });
    });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function add(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function () { return refresh(); });
  }

  function change(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) { return refresh(); }
        return r.json().then(render);
      })
      .catch(function () { return refresh(); });
  }

  function init() {
    els.cart = document.getElementById('cart');
    if (!els.cart) return;

    els.scrim = document.getElementById('scrim');
    els.cartItems = document.getElementById('cartItems');
    els.cartEmpty = document.getElementById('cartEmpty');
    els.cartCount = document.getElementById('cartCount');
    els.cartTotal = document.getElementById('cartTotal');
    els.freeship = document.getElementById('freeship');

    var openBtn = document.getElementById('openCart');
    var closeBtn = document.getElementById('closeCart');

    if (openBtn) {
      openBtn.addEventListener('click', function () { open(); refresh(); });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }
    if (els.scrim) {
      els.scrim.addEventListener('click', close);
    }

    /* bind handlers for server-rendered rows */
    bindRowHandlers();
  }

  document.addEventListener('DOMContentLoaded', init);

  window.GoLevitaCart = { open: open, close: close, add: add, change: change, refresh: refresh };
})();
/* ============================================================
   GLOBAL GUARDS
   ============================================================ */
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var designMode   = window.Shopify && window.Shopify.designMode;

/* ============================================================
   MODULE: MOBILE MENU
   ============================================================ */
(function () {
  'use strict';

  function bindMobileMenu() {
    var overlay    = document.getElementById('mobileMenu');
    var openBtn    = document.getElementById('openMenu');
    var closeBtn   = document.getElementById('closeMenu');
    var menuLinks  = document.querySelectorAll('.menu-link');

    if (!overlay) return;

    function openMenu() {
      overlay.style.transform       = 'translateY(0)';
      document.body.style.overflow  = 'hidden';
    }

    function closeMenu() {
      overlay.style.transform       = 'translateY(-100%)';
      document.body.style.overflow  = '';
    }

    if (openBtn)  openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    menuLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  document.addEventListener('DOMContentLoaded', bindMobileMenu);

  document.addEventListener('shopify:section:load', function (e) {
    /* Only re-bind if the header section was reloaded */
    if (e.target && e.target.querySelector('#mobileMenu')) {
      bindMobileMenu();
    }
  });
})();

/* ============================================================
   MODULE: MOTION (GSAP + ScrollTrigger)
   ============================================================ */
(function () {
  'use strict';

  if (reduceMotion) return;

  gsap.registerPlugin(ScrollTrigger);

  /* ---- Magnetic buttons ---- */
  function bindMagnetic(scope) {
    var scope = scope || document;
    scope.querySelectorAll('[data-magnetic]').forEach(function (el) {
      if (el.dataset.magneticBound) return;
      el.dataset.magneticBound = '1';

      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width  / 2);
        var y = e.clientY - (r.top  + r.height / 2);
        gsap.to(el, { x: x * 0.25, y: y * 0.25, duration: 0.4, ease: 'power3.out' });
      });

      el.addEventListener('mouseleave', function () {
        gsap.to(el, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1,.4)' });
      });
    });
  }

  /* ---- Phase scroll reveals ---- */
  function bindPhaseReveals(scope) {
    var container = scope || document;
    container.querySelectorAll('.phase').forEach(function (el) {
      if (el.dataset.phaseBound) return;
      el.dataset.phaseBound = '1';

      ScrollTrigger.create({
        trigger: el,
        start:   'top 85%',
        onEnter: function () {
          gsap.from(el, { y: 20, opacity: 0, duration: 0.6, ease: 'power3.out' });
        }
      });
    });
  }

  /* ---- Window load: hero + above-fold ---- */
  window.addEventListener('load', function () {
    /* Hero headline lines */
    gsap.from('#heroH .line > span', {
      yPercent: 110,
      duration: 1.1,
      ease:     'power4.out',
      stagger:  0.08,
      delay:    0.2
    });

    /* Above-fold data-reveal elements */
    gsap.from('[data-reveal]', {
      y:        28,
      opacity:  0,
      duration: 1,
      ease:     'power3.out',
      stagger:  0.08
    });

    /* Parallax tape */
    if (document.querySelector('.tape') && document.getElementById('top')) {
      gsap.to('.tape', {
        yPercent:      -30,
        ease:          'none',
        scrollTrigger: {
          trigger: '#top',
          start:   'top top',
          end:     'bottom top',
          scrub:   true
        }
      });
    }
  });

  /* ---- Phase reveals + magnetic on first load ---- */
  function initMotionBindings(scope) {
    bindMagnetic(scope);
    bindPhaseReveals(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { initMotionBindings(document); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initMotionBindings(e.target);
  });
})();

/* ============================================================
   MODULE: SMOOTH SCROLL (Lenis)
   ============================================================ */
(function () {
  'use strict';

  if (designMode || reduceMotion) {
    /* No Lenis - let the browser handle scrolling natively */
    return;
  }

  var lenis;

  function initLenis() {
    lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);

    bindHashAnchors();
  }

  function bindHashAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      if (anchor.dataset.lenisBound) return;
      anchor.dataset.lenisBound = '1';

      anchor.addEventListener('click', function (e) {
        var href = anchor.getAttribute('href');
        if (!href || href.length <= 1) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80 });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initLenis);
})();

/* ============================================================
   MODULE: COLOUR PICKER
   ============================================================ */
(function () {
  'use strict';

  function padIndex(i, total) {
    /* Pad to 2 digits: "01", "02" etc. */
    var pi = i < 10     ? '0' + i     : '' + i;
    var pt = total < 10 ? '0' + total : '' + total;
    return pi + ' / ' + pt;
  }

  function bindColourPicker(scope) {
    var container = scope || document;
    var swatches  = container.querySelectorAll('.swatch');
    if (!swatches.length) return;

    var kinImg   = document.getElementById('kinImg');
    var kinName  = document.getElementById('kinName');
    var kinCount = document.getElementById('kinCount');
    var kinAdd   = document.getElementById('kinAdd');
    var total    = swatches.length;

    swatches.forEach(function (swatch) {
      if (swatch.dataset.pickerBound) return;
      swatch.dataset.pickerBound = '1';

      /* Ensure background matches data-hex (belt-and-suspenders) */
      var hex = swatch.dataset.hex;
      if (hex) swatch.style.background = hex;

      swatch.addEventListener('click', function () {
        /* Update active state */
        document.querySelectorAll('.swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        /* Image transition */
        if (kinImg) {
          if (!reduceMotion) {
            gsap.fromTo(
              kinImg,
              { scale: 0.85, opacity: 0, rotate: -10 },
              { scale: 1,    opacity: 1, rotate:  0, duration: 0.55, ease: 'power3.out' }
            );
          }
          var img  = swatch.dataset.img;
          var name = swatch.dataset.name || '';
          if (img) kinImg.src = img;
          kinImg.alt = name + ' kinesiology tape';
        }

        /* Text / counter updates */
        if (kinName)  kinName.textContent  = swatch.dataset.name || '';
        if (kinCount) kinCount.textContent = padIndex(parseInt(swatch.dataset.i, 10) || 1, total);
        var kinPrice = document.getElementById('kinPrice');
        if (kinPrice && swatch.dataset.price) kinPrice.textContent = swatch.dataset.price;
      });
    });

    /* Add to bag */
    if (kinAdd && !kinAdd.dataset.pickerBound) {
      kinAdd.dataset.pickerBound = '1';
      kinAdd.addEventListener('click', function () {
        var active    = document.querySelector('.swatch.active');
        if (!active) return;

        var variantId = active.dataset.variantId;
        if (!variantId) {
          /* No product assigned yet - graceful no-op */
          return;
        }

        if (window.GoLevitaCart && typeof window.GoLevitaCart.add === 'function') {
          window.GoLevitaCart.add(variantId, 1);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { bindColourPicker(document); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) bindColourPicker(e.target);
  });
})();

/* ============================================================
   MODULE: CART TERMS AGREEMENT
   Checkout stays disabled until the terms checkbox is ticked.
   ============================================================ */
(function () {
  'use strict';

  function syncCartTerms() {
    var box = document.getElementById('cartTerms');
    var checkout = document.getElementById('cartCheckout');
    if (!box || !checkout) return;

    if (box.checked) {
      checkout.classList.remove('opacity-40', 'pointer-events-none');
      checkout.setAttribute('aria-disabled', 'false');
      checkout.removeAttribute('tabindex');
    } else {
      checkout.classList.add('opacity-40', 'pointer-events-none');
      checkout.setAttribute('aria-disabled', 'true');
      checkout.setAttribute('tabindex', '-1');
    }
  }

  function bindCartTerms() {
    var box = document.getElementById('cartTerms');
    var checkout = document.getElementById('cartCheckout');
    if (!box || !checkout) return;

    if (!box.dataset.termsBound) {
      box.dataset.termsBound = '1';
      box.addEventListener('change', syncCartTerms);
    }

    if (!checkout.dataset.termsBound) {
      checkout.dataset.termsBound = '1';
      /* pointer-events-none blocks clicks, but guard keyboard / edge cases too */
      checkout.addEventListener('click', function (e) {
        var cb = document.getElementById('cartTerms');
        if (!cb || !cb.checked) { e.preventDefault(); }
      });
    }

    syncCartTerms();
  }

  document.addEventListener('DOMContentLoaded', bindCartTerms);
  document.addEventListener('shopify:section:load', bindCartTerms);
})();
